import { Chip } from "@mui/material";
import {
	BooleanField,
	BooleanInput,
	CreateButton,
	Datagrid,
	DateField,
	DeleteButton,
	EditButton,
	EmailField,
	ExportButton,
	FilterButton,
	List,
	SelectInput,
	ShowButton,
	TextField,
	TextInput,
	TopToolbar,
	useRecordContext,
} from "react-admin";
import { SoftDeleteToggle } from "@/components/SoftDeleteToggle";

const appFilters = [
	<TextInput key="name" label="Name" source="name" alwaysOn />,
	<TextInput key="ownerEmail" label="Owner Email" source="ownerEmail" />,
	<BooleanInput key="active" label="Active" source="active" />,
	<BooleanInput key="testMode" label="Test Mode" source="testMode" />,
	<SelectInput
		key="attestationProvider"
		label="Attestation"
		source="attestationProvider"
		choices={[
			{ id: "none", name: "None" },
			{ id: "firebase", name: "Firebase" },
			{ id: "apple", name: "Apple" },
			{ id: "google", name: "Google" },
		]}
	/>,
];

const ListActions = () => (
	<TopToolbar>
		<FilterButton />
		<CreateButton />
		<ExportButton />
		<SoftDeleteToggle />
	</TopToolbar>
);

const DeletedChip = () => {
	const record = useRecordContext();
	if (!record?.deletedAt) return null;
	return <Chip label="Deleted" size="small" color="error" />;
};

export const AppList = () => (
	<List
		filters={appFilters}
		actions={<ListActions />}
		sort={{ field: "createdAt", order: "DESC" }}
	>
		<Datagrid rowClick="show">
			<TextField source="name" />
			<EmailField source="ownerEmail" label="Owner" />
			<BooleanField source="active" />
			<BooleanField source="testMode" label="Test Mode" />
			<TextField source="attestationProvider" label="Attestation" />
			<TextField source="iapProvider" label="IAP" />
			<DateField source="createdAt" label="Created" />
			<DeletedChip />
			<EditButton />
			<ShowButton />
			<DeleteButton />
		</Datagrid>
	</List>
);
